import script from "./MobileNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./MobileNavigation.vue?vue&type=style&index=0&id=397478f4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-397478f4"]])

export default __exports__